import UserForm from './UserForm';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import when from 'recompose/branch';
import withProps from 'recompose/withProps';
import get from 'lodash/get';

import withCountry from '../../hocs/withCountry';
import withNewUser from './withNewUser';
import withUpdateUser from './withUpdateUser';
import withLogin from './withLogin';
import withForgottonPassword from './withForgottonPassword';
import withUpdatePassword from './withUpdatePassword';
import withResendEmail from './withResendEmail';
import withShippingDetails from './withShippingDetails';
import withShippingMethods from './withShippingMethods';
import formatPrismicData from '../../hocs/formatPrismicData';

const enhance = compose(
  formatPrismicData,
  withCountry,
  withState('isSubmitted', 'setSubmitted', false),
  withProps(props => {
    const formType = get(props, 'form.type') || props.formType;
    const newProps = { formType };
    switch (formType) {
      case 'new-user':
        newProps.isNewUser = true;
        break;
      case 'log-in':
        newProps.isLogin = true;
        break;
      case 'forgot-password':
        newProps.isForgotPassword = true;
        break;
      case 'confirm-account':
        newProps.isConfirmAccount = true;
        break;
      case 'resend-email':
        newProps.isResendEmail = true;
        break;
      case 'update-user':
        newProps.isUpdateUser = true;
        break;
      case 'shipping-methods':
        newProps.isShippingMethods = true;
        break;
      case 'shipping-details':
        newProps.isShippingDetails = true;
        break;
    }

    return newProps;
  }),

  when(props => props.isNewUser, withNewUser, c => c),
  when(props => props.isUpdateUser, withUpdateUser, c => c),
  when(props => props.isLogin, withLogin, c => c),
  when(props => props.isForgotPassword, withForgottonPassword, c => c),
  when(props => props.isConfirmAccount, withUpdatePassword, c => c),
  when(props => props.isResendEmail, withResendEmail, c => c),
  when(props => props.isShippingDetails, withShippingDetails, c => c),
  when(props => props.isShippingMethods, withShippingMethods, c => c),
);

export default enhance(UserForm);



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/index.js